//  直播间尺寸适配
//  sm:     视频尺寸  480 x 360
//  md/lg:  视频尺寸  640 x 480
//  sm:  300 + 10 + 480 + 10 + 400  = 1200
//  md:  300 + 10 + 640 + 10 + 400  = 1360
//  lg:  300 + 10 + 640 + 10 + 560  = 1520


import {useState, useEffect, useCallback} from 'react'
import debounce from 'lodash/debounce';


const sidebarWidth = 70;

const width ={
  sm:1200,
  md:1320,
  lg:1440
}

const BreakPoint = {
  sm: {minWidth: width.sm + sidebarWidth, name: 'sm'},
  md: {minWidth: width.md + sidebarWidth, name: 'md'},
  // md: {minWidth: 1360 + sidebarWidth, name: 'md'},
  lg: {minWidth: width.lg + sidebarWidth, name: 'lg'}
}


// Screen Size Hook
const useScreenSize = () => {
  const isClient = typeof window === 'object'

  const getSize = useCallback(() => {
    return {
      width: isClient ? window.innerWidth : 0,
      height: isClient ? window.innerHeight : 0,
      screen: BreakPoint.sm.name
    }
  }, [isClient])

  const [screenSize, setScreenSize] = useState(getSize)

  useEffect(() => {
    if (!isClient) {
      return
    }

    const handleResize = debounce(function () {
      setScreenSize(getSize())
    }, 200)

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  if (screenSize.width < BreakPoint.md.minWidth) {
    screenSize.screen = BreakPoint.sm.name
  } else if (screenSize.width >= BreakPoint.md.minWidth && screenSize.width < BreakPoint.lg.minWidth) {
    screenSize.screen = BreakPoint.md.name
  } else if (screenSize.width >= BreakPoint.lg.minWidth) {
    screenSize.screen = BreakPoint.lg.name
  }

  return screenSize
}


export {BreakPoint,width, useScreenSize as default}
